import {ParamsToObject} from "./ParamsToObject";

export const AccountsTokens = ()=>{
    const {search} = window.location;
    if(search) {
        const query = new URLSearchParams(search);
        return ParamsToObject(query.entries());
    }
    return undefined;
}